import { NOTIFICATION_TYPE, NOTIFICATION_SUBTYPES } from './notification.types'

const getPersonNameInitials = userName => {
  const names = userName.split(' ')

  let initials = names[0].charAt(0)

  if (names.length > 1) {
    initials += names[names.length - 1].charAt(0)
  }
  return initials.toUpperCase()
}

export const getNameInitial = ({ type = '', subtype = '', parameters = '{}', userName }) => {
  try {
    const parsedParams = JSON.parse(parameters)
    const POSSIBLE_PERSON_NAME_NOTIFICATIONS: Array<string> = [
      NOTIFICATION_TYPE.REQUEST_NOTIFICATION,
      NOTIFICATION_TYPE.REQUESTING_NOTIFICATION_AND_TASK_COMPLETED
    ]

    if (type === NOTIFICATION_TYPE.REQUEST_NOTIFICATION && subtype === NOTIFICATION_SUBTYPES.PRODUCT_SETUP) {
      return parsedParams?.productName.charAt(0)
    }

    if (POSSIBLE_PERSON_NAME_NOTIFICATIONS.includes(type) && subtype === NOTIFICATION_SUBTYPES.USER_PROFILE) {
      return getPersonNameInitials(userName)
    }
    return ''
  } catch {
    return ''
  }
}
